import { useTranslation } from 'react-i18next'

import Text from '../../Text'
import { QA_NAME_GRETA_AI_CHAT_EMPTY_CHAT } from '../GretaAIChat.constants'

import * as styles from './GretaAIChatEmptyChatNotice.module.css'

function GretaAIChatEmptyChatNotice() {
  const { t } = useTranslation()

  return (
    <Text
      Element='div'
      className={styles.root}
      qaName={QA_NAME_GRETA_AI_CHAT_EMPTY_CHAT}
    >
      {t('Greta.EmptyChatKey')}
    </Text>
  )
}

export default GretaAIChatEmptyChatNotice
